export function normalizeRadio({ results }) {
  const tracks = results;

  return {
    result: {
      trackIds: tracks.map(track => track.id.toString()),
    },
  };
}
